<div class="bg-white p-5">
  <h2 class="text-xl font-bold mb-4 text-dc-navy">
    {{ "ACCOUNT.ACCESS.USER_DETAIL" | translate }}
  </h2>
  @if (loader) {
    <app-skeleton-loader
      [formLoader]="true"
      [noOfFields]="7"
    ></app-skeleton-loader>
  }
  @if (!loader) {
    <!-- ============ General information ============ -->
    <div class="border-b-2 border-gray-200">
      <h3 class="text-lg font-bold text-dc-black mb-4">
        {{ "ACCOUNT.ACCESS.GENERAL" | translate }}
      </h3>
    </div>
    <table class="dc-table-list">
      <tbody>
        <tr>
          <td>
            {{ "ACCOUNT.ACCESS.EN_NAME" | translate }}
          </td>
          <td>{{ req.englishName }}</td>
        </tr>
        <tr>
          <td>
            {{ "ACCOUNT.ACCESS.AR_NAME" | translate }}
          </td>
          <td>{{ req.arabicName }}</td>
        </tr>
        <tr>
          <td>
            {{ "ACCOUNT.ACCESS.NATIONALITY" | translate }}
          </td>
          <td>{{ req.nationality }}</td>
        </tr>
      </tbody>
    </table>
    <!-- ============ Roles ============ -->
    <div class="border-b-2 border-gray-200">
      <h3 class="text-lg font-bold text-dc-black mb-4">
        {{ "ACCOUNT.ACCESS.ROLES" | translate }}
      </h3>
    </div>
    <table class="dc-table-list">
      <tbody>
        <tr>
          <td>
            {{ "ACCOUNT.ACCESS.USER_TYPE" | translate }}
          </td>
          <td>{{ req.userType }}</td>
        </tr>
        <tr class="access-row-mobile">
          <td>
            {{ "ACCOUNT.ACCESS.ACCESS" | translate }}
          </td>
          <td>
            <div
              class="access-services-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3"
            >
              @for (s of accessableServices; track $index) {
                <label
                  class="flex items-center gap-x-2 relative cursor-default select-none pointer-events-none"
                  aria-disabled="true"
                >
                  <input
                    type="checkbox"
                    [checked]="s.checked"
                    tabindex="-1"
                    class="peer form-checkbox h-6 w-6 rounded-none border-dc-navy accent-dc-navy"
                  />

                  <!-- Custom check mark -->
                  @if (s.checked) {
                    <span
                      class="h-6 w-6 absolute text-white text-sm text-center bg-dc-navy border border-dc-navy"
                    >
                      <i class="fas fa-check"></i>
                    </span>
                  }

                  <span
                    class="text-sm sm:whitespace-nowrap"
                    [class.text-dc-navy]="s.checked"
                    [class.text-gray-400]="!s.checked"
                  >
                    {{ s.label }}
                  </span>
                </label>
              }
            </div>
          </td>
        </tr>
        <tr>
          <td>
            {{ "ACCOUNT.ACCESS.LEGAL_STATUS" | translate }}
          </td>
          <td>{{ req.legalStatus }}</td>
        </tr>
        <tr>
          <td>
            {{ "ACCOUNT.ACCESS.ISSUE_DATE" | translate }}
          </td>
          <td>{{ req.issueDate | date: "dd MMMM yyyy" }}</td>
        </tr>
      </tbody>
    </table>

    <!-- ============ Contact ============ -->
    <div class="border-b-2 border-gray-200">
      <h3 class="text-lg font-bold text-dc-black mb-4">
        {{ "ACCOUNT.ACCESS.CONTACT" | translate }}
      </h3>
    </div>
    <table class="dc-table-list">
      <tbody>
        <tr>
          <td>
            {{ "ACCOUNT.ACCESS.PHONE" | translate }}
          </td>
          <td>{{ req.phone }}</td>
        </tr>
        <tr>
          <td>
            {{ "ACCOUNT.ACCESS.EMAIL" | translate }}
          </td>
          <td>{{ req.email }}</td>
        </tr>
      </tbody>
    </table>

    <!-- action buttons -->
    @if (isPrimaryUser) {
      <div class="flex flex-wrap gap-3 mt-6">
        <app-button
          [label]="'BUTTONS.UPDATE_INFROMATION' | translate"
          classesName="btn-edge-cut"
          (onBtnClick)="update()"
        >
        </app-button>
        @if (!isSameUserAsLogin()) {
          <app-button
            [label]="'BUTTONS.REMOVE_USER' | translate"
            classesName="card-edge-cut-white"
            (onBtnClick)="removeUser()"
          >
          </app-button>
        }
      </div>
    }
  }
</div>

@if (showUnlinkConfirmation) {
  <app-confirmation-modal
    [title]="'CONFIRMATION_TITLE'"
    [message]="'REMOVE_USER_MESSAGE'"
    [confirmLabel]="'BUTTONS.OK'"
    [cancelLabel]="'BUTTONS.CANCEL'"
    [loading]="unlinkUserLoader"
    (confirm)="confirmUnLinkUser()"
    (cancel)="closeUnlinkConfirmation()"
  ></app-confirmation-modal>
}
